import { render } from "./ChatFinishedStats.vue?vue&type=template&id=3ec1c1bf&scoped=true"
import script from "./ChatFinishedStats.vue?vue&type=script&lang=js"
export * from "./ChatFinishedStats.vue?vue&type=script&lang=js"

import "./ChatFinishedStats.vue?vue&type=style&index=0&id=3ec1c1bf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec1c1bf"]])

export default __exports__